import { Component, h } from 'preact'
import ImageUploader from '../category/control/ImageUploader'
import ButtonControl from '../button-control'
import InputGroup from '../ui-components/InputGroup'
import ColorSelector from './ColorSelector'

export interface DefaultHeaderData {
  logoUrl: string,
  label: string,
  labelMobile: string,
  url: string,
  backgroundColor: string,
  linkColor: string,
}

interface Props extends DefaultHeaderData {
  onChange<K extends keyof DefaultHeaderData>(newData: Pick<DefaultHeaderData, K>): void
}

class DefaultHeader extends Component<Props> {
  constructor (props: Props) {
    super(props)
    this.state = {
      logoUrl: ''
    }
  }

  uploader: HTMLInputElement | undefined

  render ({ logoUrl, label, labelMobile, url, backgroundColor, linkColor, onChange } : Props) {
    return (
      <div className='default-header'>
        <strong>Logo</strong>
        <div>Upload your community logo in .PNG or .JPG format here</div>
        <div className='default-header_logo-image'>
          {
            logoUrl === '' ? (
              <div>
                <ButtonControl
                  class='btn btn-default btn-upload'
                  title='Upload image'
                  onClick={() => this.uploader?.click()}
                />
              </div>
            ) : (
              (
                <div className='default-header_logo-container'>
                  <div className='default-header_logo-wrapper'>
                    <img src={logoUrl} />
                  </div>
                  <div className='default-header_logo_buttons'>
                    <ButtonControl
                      class='btn btn-default btn-edit'
                      title='Edit'
                      onClick={() => this.uploader?.click()}
                    />
                    <ButtonControl
                      class='btn btn-default btn-delete'
                      title='Remove'
                      onClick={() => onChange({ logoUrl: '' })}
                    />
                  </div>
                </div>
              )
            )
          }
        </div>
        <ImageUploader
          onUploaded={({ source_thumb }: { source_thumb: string }) => onChange({ logoUrl: source_thumb })}
          uploaderRef={(ref: HTMLInputElement) => { this.uploader = ref }}
        />
        <div className='default-header_url-labels'>
          <InputGroup
            title='URL Label'
            meta='Define the label for the outgoing link'
            qaClasses='default-header_url-label'
            type='text'
            onChange={(e: ChangeEvent) => onChange({ label: e.target.value })}
            value={label} />
          <InputGroup
            title='URL Label (mobile)'
            meta='Define the label for the outgoing link for mobile viewports'
            qaClasses='default-header_url--mobile-label'
            type='text'
            onChange={(e: ChangeEvent) => onChange({ labelMobile: e.target.value })}
            value={labelMobile} />
        </div>
        <div className='default-header_url'>
          <InputGroup
            title='URL'
            meta='Define the URL for the outgoing link'
            qaClasses='default-header_url'
            type='text'
            onChange={(e: ChangeEvent) => onChange({ url: e.target.value })}
            value={url} />
        </div>
        <div className='default-header_colors'>
          <ColorSelector
            title='Background Color'
            className='default-header_background_color'
            meta='Define the background color for the community header'
            selectedColor={backgroundColor}
            onCallback={(color: string) => onChange({ backgroundColor: color })}
          />
          <ColorSelector
            title='Link Color'
            className='default-header_text_color'
            meta='Define the text color of the link to the website'
            selectedColor={linkColor}
            onCallback={(color: string) => onChange({ linkColor: color })}
          />
        </div>
      </div>
    )
  }
}

export default DefaultHeader
